import { render } from "./CardComentarioItem.vue?vue&type=template&id=b77df680&scoped=true"
import script from "./CardComentarioItem.vue?vue&type=script&lang=js"
export * from "./CardComentarioItem.vue?vue&type=script&lang=js"

import "./CardComentarioItem.vue?vue&type=style&index=0&id=b77df680&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b77df680"]])

export default __exports__